import { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { api } from '../api';
import { IconCheckCircle, IconXCircle } from '../components/AuthIcons';

export default function VerifyEmail({ token, onSuccess }) {
  const { t } = useTranslation();
  const [status, setStatus] = useState('loading'); // loading | ok | error
  const [error, setError]   = useState('');
  const called = useRef(false);

  useEffect(() => {
    if (called.current) return;
    called.current = true;
    api.verifyEmail(token)
      .then(() => {
        setStatus('ok');
        window.history.replaceState({}, '', window.location.pathname);
        setTimeout(onSuccess, 2500);
      })
      .catch(e => {
        setStatus('error');
        setError(e.message);
      });
  }, [token]);

  return (
    <div style={{
      minHeight: '100vh', background: 'var(--bg)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '24px',
    }}>
      <div style={{ width: '100%', maxWidth: '380px' }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <h1 style={{ fontSize: '28px', fontWeight: 800, color: 'var(--acc2)', letterSpacing: '-0.02em', marginBottom: '6px' }}>
            ScanPilots
          </h1>
        </div>
        <div className="ds-card" style={{ padding: '32px 24px', textAlign: 'center' }}>
          {status === 'loading' && (
            <>
              <div style={{ width: '32px', height: '32px', border: '3px solid var(--border)', borderTopColor: 'var(--acc)', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 16px' }} />
              <p style={{ fontSize: '13px', color: 'var(--ink3)' }}>{t('auth.verifying')}</p>
              <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
            </>
          )}
          {status === 'ok' && (
            <>
              <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}><IconCheckCircle size={60} /></div>
              <h2 style={{ fontSize: '15px', fontWeight: 700, color: 'var(--ok2)', marginBottom: '10px' }}>
                {t('auth.verifySuccess')}
              </h2>
              <p style={{ fontSize: '12px', color: 'var(--ink3)', lineHeight: '1.6' }}>
                {t('auth.verifySuccessDesc')}
              </p>
            </>
          )}
          {status === 'error' && (
            <>
              <div style={{ marginBottom: '16px', display: 'flex', justifyContent: 'center' }}><IconXCircle size={60} /></div>
              <h2 style={{ fontSize: '15px', fontWeight: 700, color: 'var(--err2)', marginBottom: '10px' }}>
                {t('auth.verifyError')}
              </h2>
              <p style={{ fontSize: '12px', color: 'var(--ink3)', lineHeight: '1.6', marginBottom: '20px' }}>
                {error}
              </p>
              <button onClick={onSuccess}
                style={{ background: 'var(--bg4)', border: '1px solid var(--border)', borderRadius: '8px', color: 'var(--ink)', padding: '8px 20px', fontSize: '11px', fontWeight: 600, cursor: 'pointer' }}>
                {t('auth.backToLogin')}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
